import { createContext, useContext } from "react";
import { CustomEventConfig, CalendarCategory, WeekAvailable } from "../../models/calendar/Calendar.model";

export type SelectedCalendar = {
    id: string; // Numeric ID from Supabase
    uid: string; // UUID from Firestore
    color: string;
    availableWeekRules: boolean[];
    weekAvailable: WeekAvailable[];
    customEvents?: CustomEventConfig[];
    category?: CalendarCategory;
  }

export const CalendarContext = createContext<{ 
  calendar: SelectedCalendar; 
  setCalendar: React.Dispatch<React.SetStateAction<SelectedCalendar>> 
} | undefined>(undefined);

export const useCalendar = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error('useCalendar must be used within a CalendarContext.provider');
  }
  return context;
};